var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_263_1468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.71422 13.0714L10.8311 16.2857C12.2978 12.0725 13.5193 10.2238 16.2856 7.71428M11.9999 22.7143C17.9173 22.7143 22.7142 17.9174 22.7142 12C22.7142 6.08265 17.9173 1.28571 11.9999 1.28571C6.08259 1.28571 1.28564 6.08265 1.28564 12C1.28564 17.9174 6.08259 22.7143 11.9999 22.7143Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_263_1468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export { SvgCheckCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNjNfMTQ2OCkiPgogICAgICAgIDxwYXRoIGQ9Ik03LjcxNDIyIDEzLjA3MTRMMTAuODMxMSAxNi4yODU3QzEyLjI5NzggMTIuMDcyNSAxMy41MTkzIDEwLjIyMzggMTYuMjg1NiA3LjcxNDI4TTExLjk5OTkgMjIuNzE0M0MxNy45MTczIDIyLjcxNDMgMjIuNzE0MiAxNy45MTc0IDIyLjcxNDIgMTJDMjIuNzE0MiA2LjA4MjY1IDE3LjkxNzMgMS4yODU3MSAxMS45OTk5IDEuMjg1NzFDNi4wODI1OSAxLjI4NTcxIDEuMjg1NjQgNi4wODI2NSAxLjI4NTY0IDEyQzEuMjg1NjQgMTcuOTE3NCA2LjA4MjU5IDIyLjcxNDMgMTEuOTk5OSAyMi43MTQzWiIKICAgICAgICAgICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjcxNDI5IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzI2M18xNDY4Ij4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";